import React from 'react';

import { createCn } from 'bem-react-classname';
import cn from 'classnames';
import moment from 'moment';
import { Kit } from 'ui/Kit';

import { ActionsStatsChart } from '../../components/ActionsStatsChart';
import { DashboardMenu } from '../../components/DashboardMenu';

import './ActionsStatsPage.scss';

interface Props {}

const cx = createCn('ActionsStatsPage');

export const ActionsStatsPage: React.FC = () => {
  return (
    <div className={cn(cx())}>
      <DashboardMenu />

      <Kit.Title>System user actions</Kit.Title>

      <div className={cx('graph')}>
        <ActionsStatsChart fromDate={moment().subtract(12, 'month').format()} />
      </div>
    </div>
  );
};
